module.exports = __webpack_public_path__ + "static/library@large-d10ce506809da77f9797658a1ca545aa.jpg";